export const documentTypesOptions = [
  { value: 'cedula', label: 'Cédula' },
  { value: 'pasaporte', label: 'Pasaporte' },
  { value: 'ruc', label: 'Ruc' },
  { value: 'rut', label: 'Rut' },
  { value: 'otro', label: 'Otro' }
];